<template>
  <Modal
    data-test-id="modal-link-protocol"
    is-open
    :title="
      $tc('protocol.linking.link_protocol', undefined, {
        field: element.label,
        target: targetProtocolType?.name || $tc('unknown'),
      })
    "
    :max-width="1200"
    view-only
    @cancel="$emit('cancel')"
  >
    <ProtocolTable
      id="dataTable"
      class="ma-0"
      :protocols="allLinkableProtocols"
      :is-loading="linkableProtocolsLoading"
      :loading-message="$tc('loading', undefined, { entity: $tc('protocol.linking.linkable_protocols') })"
      :search-bar-title="$tc('protocol.linking.choose_linked_protocol')"
      start-with-all-dates
      hide-deleted
      scroll-target=".v-dialog"
      @protocol-clicked="linkProtocol"
    >
      <template #componentBeforeTableStart>
        <div class="flex justify-center items-center h-13.5">
          <button
            v-t="'protocol.proceed_without_link'"
            class="text-primary text-sm font-semibold border-solid border-1 border-primary rounded h-10.5 px-1 py-2.5"
            data-test="button-createWithoutLink"
            @click="linkProtocol(undefined)"
          />
        </div>
      </template>
    </ProtocolTable>
  </Modal>
</template>

<script lang="ts">
import { Protocol, ProtocolLink, ProtocolLinkElement } from '@anschuetz-elog/common';
import { computed, defineComponent, PropType, toRef } from 'vue';

import Modal from '#/components/Modal.vue';
import ProtocolTable from '#/components/protocol/ProtocolTable.vue';
import useFeathers from '#/compositions/useFeathers';
import { getHistoricProtocolTypeIds, loadProtocols } from '#/compositions/useProtocols';
import { getLinkValue } from '#/helpers/ProtocolUtilities';

export default defineComponent({
  name: 'FormProtocolLink',

  components: {
    Modal,
    ProtocolTable,
  },

  props: {
    element: {
      type: Object as PropType<ProtocolLinkElement>,
      required: true,
    },
  },

  emits: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    link: (_link: ProtocolLink | undefined) => true,
    cancel: () => true,
  },

  setup(props, { emit }) {
    const element = toRef(props, 'element');

    const feathers = useFeathers();
    const localCache = feathers.get('localCache');

    const targetProtocolType = computed(() => {
      return localCache.getOptionalProtocolType(element.value.protocolType);
    });

    const { data: allLinkableProtocols, isLoading: linkableProtocolsLoading } = loadProtocols(
      getHistoricProtocolTypeIds(targetProtocolType),
    );

    function linkProtocol(selectedProtocol: Protocol | undefined): void {
      emit('cancel');
      if (!selectedProtocol) {
        emit('link', undefined);
        return;
      }
      emit('link', getLinkValue(selectedProtocol, element.value));
    }

    return {
      linkableProtocolsLoading,
      linkProtocol,
      allLinkableProtocols,
      targetProtocolType,
    };
  },
});
</script>
